module.exports = __webpack_public_path__ + "assets/xinxitougao.7d87be5a.svg";